import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CategoriesService } from '../../../services/categories.service';
import { Category } from '../../../models/questions';
import { ParamMap, ActivatedRoute } from '../../../../../node_modules/@angular/router';
import { switchMap } from '../../../../../node_modules/rxjs/operators';

@Component({
  selector: 'app-categories-list',
  templateUrl: './categories-list.component.html',
  styleUrls: ['./categories-list.component.scss']
})
export class CategoriesListComponent implements OnInit {

    @Output() categoryChange = new EventEmitter<Category>();
    categories: Array<Category>;
    searchText = '';
    selectedCategoryId: number;

    constructor(private categoriesService: CategoriesService, private readonly route: ActivatedRoute) {
      this.updateAfterEdit();
      this.updateAfterAdd();
      this.updateAfterDelete();
    }

  ngOnInit() {
    this.route.paramMap.pipe(
      switchMap((params: ParamMap) => {
        this.selectedCategoryId = (params.get('id')) ? +params.get('id') : this.selectedCategoryId;
        return this.categoriesService.getAll();
      }))
    .subscribe(x => {
        this.getAllCategories(x);
      });
    
  }

  changeCategory(selectedCategory: Category) {
    this.categoryChange.emit(selectedCategory);
  }

  private updateAfterEdit() {
    this.categoriesService.saveOnEditCategoryClicked$
    .subscribe(x => {
      if (this.categories) {
        let categoryToUpdate = this.categories.find(c => x.id === c.id);
        categoryToUpdate = x;
      }
    });
  }

  private updateAfterAdd() {
    this.categoriesService.saveOnAddCategoryClicked$
    .pipe(switchMap(x => this.categoriesService.getAll()))
    .subscribe(x => {
      this.getAllCategories(x);
    });
  }

  private updateAfterDelete() {
    this.categoriesService.deleteCategoryClicked$
    .pipe(
      switchMap(x => this.categoriesService.getAll())
    )
    .subscribe(x => this.getAllCategories(x));
  }

  private getAllCategories(categories: Array<Category>) {
      this.categories = categories;
      this.sortCategoriesByName(this.categories);

      this.selectedCategoryId = (this.selectedCategoryId && this.getIsCategoryExists(categories)) ? 
      this.selectedCategoryId : [...categories].shift().id;
      const selectedCategory = categories.find(c => this.selectedCategoryId === c.id);
      this.categoryChange.emit(selectedCategory);
  }

  private getIsCategoryExists(categories: Array<Category>): boolean {
    return categories.findIndex(x => x.id === this.selectedCategoryId) !== -1;
  }

  private sortCategoriesByName(categories: Array<Category>) {
    return categories.sort((a, b) => a.name.localeCompare(b.name));
  }
}
